import { apiPagamentiProvider } from "./apiPagamentiProvider";
import { mockPagamentiProvider } from "./mockPagamentiProvider";
import { isMockEnabled } from "../../../config/featureConfig";

export const pagamentiProvider = isMockEnabled("pagamenti")
  ? mockPagamentiProvider
  : apiPagamentiProvider;

